import { createAction } from '@reduxjs/toolkit';

import { Boat } from '../types';

export const setBoats = createAction<Boat[]>('SET_USER_BOATS');

export const setSelectedBoatId = createAction<number | null>(
  'SET_SELECTED_BOAT_ID',
);

export const BoatsActions = {
  setBoats,
  setSelectedBoatId,
};
